import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
export default function getIconName(linkItem) {
  if (!linkItem) {
    return '';
  }

  var iconName = linkItem.icon || linkItem.style;
  return iconName ? iconName.replace('h-', '') : '';
}